<script setup lang="ts">
import StatCard from '@/components/ui/StatCard.vue';
import type { OpenIssuesStat } from '@/api/dashboard-types';

defineProps<{
  stat: OpenIssuesStat | null;
  loading?: boolean;
}>();
</script>

<template>
  <div data-testid="open-issues-stat">
    <StatCard
      label="Open issues"
      :value="loading || !stat ? '—' : stat.total"
      :sub="stat ? `${stat.critical} critical` : undefined"
    />
  </div>
</template>
